export const home = {
  hero: {
    titleLine1: '把实验室装进兜兜',
    titleLine2: '让健康随身go',
    titleLine3: '',
    subtitle: '膳兜兜 foodgogo 是依托食品实验室的新锐健康品牌',
    description: '',
    ctaPrimary: '探索产品系列',
    ctaSecondary: '了解品牌故事',
    card1: '软糖系列',
    card1Sub: '口袋实验室',
    card2: '冻干滋补',
    card2Sub: '黑科技系列',
    card3: '草本能量棒',
    card3Sub: '朋克养生',
  },
  products: {
    sectionTitle: '功能性营养矩阵',
    sectionDesc: '三大赛道，覆盖轻养生全场景——从口袋里的微型实验室，到还原自然的黑科技，再到新中式朋克养生。',
    freezeDried: {
      category: '冻干即食滋补',
      tag: '黑科技系列',
      name1: '冻干银耳羹 / 燕窝粥',
      desc1: '传统需要炖煮4小时，现在只需开水冲泡60秒。FD冻干技术锁住98%以上营养。',
      features1: ['FD冻干锁鲜', '60秒即食', '98%营养保留'],
      name2: '益生菌冻干粉',
      desc2: '针对肠道健康，搭配膳食纤维。低温破壁技术，让营养更容易被人体吸收。',
      features2: ['低温破壁', '膳食纤维', '肠道健康'],
      name3: '冻干水果脆片',
      desc3: '无花果、黄桃、桑葚药食同源水果。保留原果形态和营养，办公室解馋零食首选。',
      features3: ['药食同源', '原果形态', '便携即食'],
    },
    gummies: {
      category: '功能性软糖',
      tag: '口袋实验室',
      name1: '熬夜急救软糖',
      desc1: '人参、葛根、菊花提取物微胶囊包埋，护肝明目。0糖0脂，天然代糖赤藓糖醇。',
      features1: ['微胶囊包埋', '0糖0脂', '清洁标签'],
      name2: '助眠晚安糖',
      desc2: '酸枣仁、GABA、薰衣草提取物。解决失眠焦虑，让每一晚都获得实验室级的优质睡眠。',
      features2: ['GABA助眠', '酸枣仁天然', '0糖配方'],
    },
    energyBars: {
      category: '中式草本能量棒',
      tag: '朋克养生',
      name1: '黑芝麻丸升级版',
      desc1: '结合DHA藻油与益生菌，以黑养黑。控卡技术精准计算热量，满足减脂人群需求。',
      features1: ['DHA+益生菌', '控卡精准', '酶解去涩'],
    },
    cta: '查看详情',
  },
  lab: {
    sectionLabel: 'LAB NOTES',
    sectionTitle: '前沿萃取科技',
    freezeDry: {
      title: '零下40℃冻干锁鲜',
      stat: '-40°C',
      statLabel: '冻干温度',
      description: 'FD冻干技术在真空环境下将食材水分直接升华，最大程度保留色、香、味及活性营养成分。',
      badge: '核心技术专利',
    },
    microEncapsulation: {
      title: '微胶囊靶向包埋',
      stat: '98%',
      statLabel: '活性保留率',
      description: '利用微胶囊技术包裹活性成分，解决传统中药口感苦涩的问题，精准释放营养。',
      badge: '冷萃技术',
    },
    cleanLabel: {
      title: '清洁标签承诺',
      stat: '0',
      statLabel: '化学添加剂',
      description: '拒绝化学添加剂的过度修饰。最好的配方师是大自然，实验室的使命是剔除杂质，留下精华。',
    },
  },
  about: {
    label: 'Brand Philosophy',
    title: '把实验室',
    titleLine2: '搬进日常',
    description: '膳兜兜相信，真正的绿色健康不是盲目回归原始，而是用前沿科技还原自然的本真。\n我们深入全球优质原产地，寻找最纯净的绿色食材，然后运用尖端技术，将食材中的活性营养精准锁定。',
    manifesto: {
      label: 'Research Manifesto',
      text: '每一款产品的背后，都是无数次的数据测试与感官打磨。我们拒绝化学添加剂的过度修饰，坚持清洁标签。在膳兜兜看来，最好的配方师是大自然，而实验室的使命，是剔除杂质，留下精华。',
      founderName: '膳兜兜实验室',
      founderRole: '食品科学研发团队',
    },
    stats: [
      { number: '200+', label: '配方迭代实验' },
      { number: '36', label: '全球优质产地' },
      { number: '0', label: '化学添加承诺' },
      { number: '98%', label: '营养活性保留' },
    ],
  },
  testimonials: {
    sectionLabel: '真实体验',
    sectionTitle: '来自口袋里的反馈',
    list: [
      { name: '林小安', role: '互联网产品经理', content: '作为996党，熬夜急救软糖真的救了我。以前喝咖啡喝到心悸，现在两颗软糖提神不伤身，同事都被我安利了。' },
      { name: '陈墨', role: '瑜伽教练', content: '冻干银耳羹太方便了！以前炖银耳要提前泡+炖2小时，现在早上冲一杯60秒搞定，胶质满满，学员都问我吃的什么。' },
      { name: '周周', role: '研究生在读', content: '论文季失眠全靠助眠晚安糖，不像褪黑素那样有依赖感，GABA+酸枣仁的组合醒来脑袋很清醒。' },
      { name: '王大力', role: '健身教练', content: '黑芝麻丸升级版的DHA+益生菌配方很走心，健身人群也需要养护头发，高蛋白植物肉脯训练后吃也毫无负担。' },
      { name: '苏苏', role: '设计师', content: '包装审美在线！独立小包装放包里很方便，陈皮红豆糕祛湿效果不错，湿气重的时候整个人精神多了。' },
    ],
  },
  cta: {
    title: '让健康不再是静止的守候',
    titleAccent: '而是动态的随行',
    description: '无论你在写字楼的格子间，还是在户外的山川湖海',
    descriptionAccent: '膳兜兜 foodgogo',
    descriptionEnd: '都希望能成为你口袋里的能量补给站。',
    buttonText: '立即开启轻养生',
  },
};